import z from "zod"
import { customersSortFields } from "../customers/dtos"
import { createFilterBySchema } from "../shared/filter_dtos"
import { PaginationSchema } from "../shared/pagination_dtos"
import { QuerySchema } from "../shared/query_dtos"
import { createSortSchema } from "../shared/sort_dtos"

export const PredefinedSegmentGroups = {
  satisfaction: "satisfaction",
  country: "country",
  language: "language",
  companyClient: "companyClient",
  purchaseRecency: "purchaseRecency",
  rfm: "rfm",
} as const

export const OthersDynamicSegmentName = "__others__"
export const UnknownSegmentName = "__unknown__"

export const GetSegmentParams = z.object({
  id: z.string().transform(BigInt),
})

export const GetSegmentGroupParams = z.object({
  id: z.string().transform(BigInt),
})

export const GetSegmentGroupsComparisonParams = z.object({
  id: z.string().transform(BigInt),
  compareId: z.string().transform(BigInt),
})

const segmentsSortFields = ["name", "count", "order"] as const
export type SegmentsSortFields = (typeof segmentsSortFields)[number]
export const SegmentsSortSchema = createSortSchema(segmentsSortFields, "order", "asc")

export type CustomersInSegmentsortFields = (typeof customersSortFields)[number]
export const CustomersInSegmentsSortSchema = createSortSchema(customersSortFields, "name", "asc")

export const GetSegmentsFilterBy = createFilterBySchema([
  {
    key: "groupId",
    value: z.string().transform(BigInt).optional(),
  } as const,
])

export const GetSegmentsSchema = z.object({
  ...PaginationSchema.merge(QuerySchema).merge(SegmentsSortSchema).merge(GetSegmentsFilterBy).shape,
})

export const GetCustomersInSegmentSchema = z.object({
  ...PaginationSchema.merge(CustomersInSegmentsSortSchema).shape,
})

const segmentGroupsSortFields = ["system", "createdAt"] as const
export type SegmentGroupsSortFields = (typeof segmentGroupsSortFields)[number]
export const SegmentGroupsSortSchema = createSortSchema(segmentGroupsSortFields, "system", "asc")

export const GetSegmentGroupsSchema = z.object({
  ...PaginationSchema.merge(QuerySchema).merge(SegmentGroupsSortSchema).shape,
})
